'use client'
import _PaginationCarousel from '@/components/pagination-carousel'
import { ComponentProps, useContext } from 'react'
import { SearchCarouselContext } from '../carousel-context-manager'

const PaginationCarousel = ({
    ...componentProps
}: Omit<ComponentProps<typeof _PaginationCarousel>, 'startIndex' | 'onChange'>) => {
    const { carouselIndex, setCarouselIndex } = useContext(SearchCarouselContext)
    return (
        <_PaginationCarousel
            {...componentProps}
            startIndex={carouselIndex}
            onChange={(index) => {
                setCarouselIndex(index)
            }}
        />
    )
}
export default PaginationCarousel
